<template>
  <div class="d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="receipts-reports"
      :filtersValue="filtersValue"
      :sort="sort"
      :date="date"
      :externalFilters="pageSize"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Чеки</h1>
        <select v-model="pageSize" class="custom-select mr-2" style="max-width: 6em;">
          <option v-for="size in pageSizes" :value="size">{{size}}</option>
        </select>
        <btn-filters
          :data="data"
          endpoint="receipts-reports"
          v-model="filtersValue"
          :range="true"
          :date.sync="date"
        ></btn-filters>
      </div>
    </div>

    <data-table-full-height
      v-if="data && data.data"
      :data="data.data"
      @sort-change="sortChange"
      show-summary
    >
      <table-column-serial-number :fixed="true"/>
      <table-column-string prop="address" label="Адрес установки" :show-overflow-tooltip="true" min-width="275" tableColumnType="string"/>
      <table-column-element align="right" sortable="custom" prop="count" label="Всего чеков, шт." min-width="100" max-width="105" currencySymbol="шт." tableColumnType="number">
        <template slot-scope="{row}">
          <router-link :to="{ path: '/receipts', query: { machine_id: row.id }}">
            <number :number="row.count" currencySymbol="шт."/>
          </router-link>
        </template>
      </table-column-element>
      <table-column-number align="right" sortable="custom" prop="sum_total" label="Сумма всего" min-width="95" max-width="105" currencySymbol="₽" tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="successful" label="Удачных" min-width="85" max-width="90" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_successful" label="Сумма удачных" min-width="115" max-width="120" currencySymbol="₽" tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="unsuccessful" label="Неудачных" min-width="95" max-width="100" currencySymbol="шт." tableColumnType="number"/>
      <table-column-number align="right" sortable="custom" prop="sum_unsuccessful" label="Сумма неудачных" min-width="128" max-width="130" currencySymbol="₽" tableColumnType="number"/>

      <table-column-date prop="last_receipt" label="Последний чек" align="right"/>
    </data-table-full-height>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    metaInfo: {title: 'Чеки'},
    data () {
      return {
        filtersValue: null,
        data: {},
        sort: null,
        date: {
          min: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          max: moment().format('YYYY-MM-DD'),
        },
        pageSizes: [100, 250, 500, 1000],
        pageSize: 100,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/reports/receipts.vue